class GeolocationType {
  constructor(location = {}) {
    // This id is required for the getCollection() getter.
    this.id = location.code || '';
    this.code = location.code || '';
    this.name = location.name || '';
  }

  static fromApi(location = {}) {
    return {
      // This id is required for the getCollection() getter.
      id: location.isoCode,
      code: location.isoCode,
      name: location.name,
    };
  }
}

export default GeolocationType;
